import videoReducer from './reducer';
export { default as videoActions } from './actions';
export { default as videoTypes } from './types';
export default videoReducer;